export default function PHP_children() {
  return (
    <div>
      <h1>PHP_children</h1>
    </div>
  );
}
